export default __webpack_public_path__ + "static/inside-bg-2-ed333c2e964284a17a11fa5f76051a52.jpg";